{
  "WALLBOARD": {
    "LOADING": "Telefoonwachtrijen laden...",
    "NO_QUEUES": "Geen telefoonwachtrijen gevonden.",
    "NO_AGENTS": "Geen online agenten in deze wachtrij.",
    "UNKNOWN_CALLER": "Onbekende beller",
    "STATUS": "Status",
    "TIME": "Tijd",
    "AGENT": "Agent",
    "EXTENSION": "Extensie",
    "READY": "Gereed staande agenten",
    "ON_CALL": "Agenten in gesprek",
    "PAUSED": "Agenten met pauze",
    "WAITING": "Wachtende oproepen",
    "MISSED_CALLS": "Gemiste oproepen",
    "HANDLED_CALLS": "Afgehandelde inkomende oproepen",
    "OUTBOUND_CALLS": "Afgehandelde uitgaande oproepen",
    "AVAILABILITY": "Beschikbaarheid",
    "AVAILABILITY_TOOLTIP": "Percentage inkomende oproepen dat door agenten is beantwoord (oproepen die zijn opgenomen)",
    "AGENTS_COUNT": "({onCall} in gesprek / {total} totaal)",
    "NO_AVAILABLE": "(niemand online)",
    "WAITING_CALLERS_COUNT": "{count} wachtend",
    "CALLER": "Beller",
    "NUMBER": "Nummer",
    "WAIT_TIME": "Wachttijd",
    "ACTION": "Actie",
    "PICKUP_CALL": "Opnemen",
    "PICKUP_SUCCESS": "Verzoek om de oproep op te nemen is succesvol verstuurd.",
    "PICKUP_ERROR": "Kan de oproep niet opnemen. Probeer het opnieuw.",
    "PICKUP_DISABLED_TOOLTIP": "Je kunt geen oproep opnemen terwijl je al in gesprek bent of offline bent.",
    "CHAT_STATUS": {
      "NO_ACCESS": "Geen toegang"
    },
    "PHONE_STATUS": {
      "NO_ACCESS": "Geen toegang"
    }
  }
}
